<template>
  <div class="pb-5 d-flex justify-content-end min-vh-100">
    <QuestionnaireSideBar
      :questionnaireOptions="partList"
      :questionnaireId="questionnaireId"
      :finishCount="finishCount"
    />
    <div class="body">
      <div v-if="isConfirm" class="is-published-wrapper">
        <p>您已填寫過問卷，無法更改答案。</p>
      </div>

      <div class="header flex-column align-items-start" style="background: white; z-index: 3;">
        <div class="d-flex justify-content-between w-100">
          <h1>{{ title }}</h1>
          <div class="d-flex" v-if="$route.params.id">
            <CButton
              class="text-white me-2"
              type="submit"
              color="primary"
              @click="editQue()"
              :disabled="isConfirm"
              >{{"儲存問卷 Save Questionnaire"}}</CButton
            >
            <CButton
              type="submit"
              class="text-white"
              color="primary"
              @click="saveQue()"
              :disabled="isConfirm"
              >{{'完成填寫 Complete and Submit Questionnaire'}}</CButton
            >
          </div>
        </div>
        <h2>{{ partTitle }}</h2>
      </div>
      <CContainer fluid class="que-content">
        <div
          v-for="(item) in list"
          :key="item"
          class="col-10 py-4 mx-auto"
        >
          <div v-if="(item.type !== $defines.ItemTypes.Introduction)">
            <div class="d-flex justify-content-between align-items-center">
              <div class="topic mt-3 d-flex">
                {{ item.itemIndex }}.
  <!--              <div class="text-danger">*</div>-->
                <div class="mx-2 item-title">
                  {{ item.title }}
                </div>
                <CBadge
                  color="primary"
                  v-if="item.type === 'ChoiceOne'"
                  class="ms-2"
                  style="height: 30px"
                  >{{"單選 Select one"}}</CBadge
                >
                <CBadge
                  color="primary"
                  v-if="item.type === 'ChoiceMultiple'"
                  class="ms-2"
                  style="height: 30px"
                  >複選</CBadge
                >
              </div>
            </div>
            <p
              v-if="item.description"
              class="remark ms-4"
              style="border-top: 1px solid rgba(0, 0, 0, 0.1); padding-top: 10px"
            >
              {{ item.description }}
            </p>
          </div>
          <div
            class="preview-img"
            v-if="item.image"
            @click="enlargeImg = !enlargeImg"
          >
            <CImage
              class="mb-4"
              rounded
              thumbnail
              width="200"
              height="200"
              :src="item.image"
            />
            <img class="enlarge" src="@/assets/icons/enlarge.svg" alt="" />
            <EnLargeImg :show="enlargeImg" :image="item.image" />
          </div>
          <component
            :is="
              item.type === 'ColumnInput' || item.type === 'Scale'
                ? null
                : $defines.ItemTypesMap[item.type]
            "
            :info="item"
            @content="questionnaireAnswer"
          />
          <Nest
            v-if="item.type === 'Scale'"
            :info="item"
            @content="questionnaireAnswer"
          />
          <Form
            v-if="item.type === 'ColumnInput'"
            :info="item"
            @content="questionnaireAnswer"
          />
          <!-- 20031124 modify insert textarea -->
          <div
            v-if="(item.type !== $defines.ItemTypes.Introduction)"
            class="py-2 flex flex-col"
          >
            <button class="not-sure w-150px m-0"
              :class="{ 'sure-active' : +item.is_help }"
              @click="item.is_help === '1' ? delete item.is_help : item.is_help = '1'"
            > {{item.is_help === '1' ? '取消 Cancel' : '需要專人協助 Help (JYG will reach to you via email)'}}
            </button>
            <div
              v-if="item.is_help === '1'"
              class="mt-1"
            >
              <CFormTextarea
                v-model="item.help_message"
                placeholder="請填入文字 Please enter text"
                rows="3"
                @change="ChangeHelpText(item)"
              />
            </div>
          </div>

        </div>
        <div
          v-if="!$route.params.id"
          class="d-flex justify-content-center align-items-center flex-column"
        >
          <img class="col-6 mb-5" src="@/assets/images/logo-black.svg" alt="" />
          <div class="text-start col-8 intro">
            <p>敬愛的用戶您好：</p>
            <p>
              本問卷為『
              {{ title }}
              』，填答時請記得儲存後再送出，一但填答完成後將無法更改答案。
            </p>
          </div>
          <!-- <CButton
            type="submit"
            class="submit-button text-white me-2"
            color="primary"
            @click="$router.push(`/questionnaire/${id}/${partList[0].part_id}`)"
            >開始作答</CButton
          > -->
        </div>
      </CContainer>
    </div>
  </div>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import Input from '@/components/QuestionnaireContent/Input.vue'
import File from '@/components/QuestionnaireContent/File.vue'
import NumberInput from '@/components/QuestionnaireContent/NumberInput.vue'
import Radio from '@/components/QuestionnaireContent/Radio.vue'
import Nest from '@/components/QuestionnaireContent/Nest.vue'
import Form from '@/components/QuestionnaireContent/Form.vue'
import RangeBar from '@/components/QuestionnaireContent/RangeBar.vue'
import Textarea from '@/components/QuestionnaireContent/Textarea.vue'
import CheckBox from '@/components/QuestionnaireContent/CheckBox.vue'
import CategoryTitle from '@/components/QuestionnaireContent/CategoryTitle.vue'
import Divider from '@/components/QuestionnaireContent/Divider.vue'
import Star from '@/components/QuestionnaireContent/Star.vue'
import Date from '@/components/QuestionnaireContent/Date.vue'
import ItemSort from '@/components/QuestionnaireContent/ItemSort.vue'
import EnLargeImg from '@/components/QuestionnaireContent/EnLargeImg.vue'
import DynamicForm from "@/components/QuestionnaireContent/DynamicForm.vue"
import QuestionnaireSideBar from '@/views/Questionnaire/QuestionnaireSideBar.vue'
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref
} from '@vue/runtime-core'
import useQuestionnaire from '@/composables/useQuestionnaire'
import MsgBox from '@/components/MsgBox.vue'
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import MessageBox from '@/plugins/MessageBox'
import { SAVE_ACTION_SAVE, ItemTypes, SAVE_ACTION_CONFIRM } from '../../defines'
export default {
  components: {
    QuestionnaireSideBar,
    Input,
    Radio,
    Nest,
    RangeBar,
    Textarea,
    CheckBox,
    NumberInput,
    File,
    CategoryTitle,
    Star,
    Divider,
    ItemSort,
    Date,
    MsgBox,
    Form,
    DynamicForm,
    EnLargeImg,
  },
  setup() {
    const {
      getQuestionnaire,
      getQuestionnaireList,
      fillQuestionnaire,
      getFillList,
      getFillInfo,
    } = useQuestionnaire()
    const title = ref('')
    const partTitle = ref('')
    const list = ref([])
    const errorCode = ref('')
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const answerList = ref([])
    const originAnswerList = ref([])
    const questionnaireId = ref('')
    const dataId = ref('')
    const fillList = ref([])
    const route = useRoute()
    const partList = ref([])
    const isConfirm = ref(false)
    const enlargeImg = ref(false)
    const id = ref(null)
    const x = ref({})
    const originListStr = ref('[]')
    const finishCount = ref([])
    const router = useRouter()
    const getNestAndFormId = () => {
      const nestAndFormId =
        list.value?.reduce((accu, cur) => {
          if (cur.type === '3' || cur.type === '13') {
            accu[cur.id] = false
          }
          return accu
        }, {}) || {}
      x.value = nestAndFormId
    }
    onBeforeRouteUpdate(async (to) => {
      const leave = () => {
        list.value = []
        answerList.value = []
        nextTick(async () => {
          list.value = partList.value?.find((e) => {
            return +e.part_id === +to.params.part
          })?.items
          partTitle.value = partList.value?.find((e) => {
            return e.id === +route.params.id
          })?.title
          list.value.forEach((e) => (e.value_info = null))
          list.value.reduce((accu, cur) => {
            if (cur.type !== ItemTypes.Introduction) {
              cur.itemIndex = accu
              return accu + 1
            }else{
              return accu
            }
          }, 1)
          const fillInfo = await getFillInfo({
            id: route.params.id ? route.params.id : id.value,
            part_id: to.params.part,
          })
          if (fillInfo.error) {
            showMsgBox.value = true
            errorMsg.value = fillInfo.msg
            errorCode.value = fillInfo.error
          } else {
            fillList.value = fillInfo.ret.info.result_items
            finishCount.value = fillInfo.ret.info.finish_count
            dataId.value = fillList.value?.id
            isConfirm.value = +fillInfo.ret.info.is_confirm === 1
            nextTick(() => {
              originListStr.value = JSON.stringify(fillList.value)
            })

            fillList.value?.forEach((answer) => {
              if(+answer.part_id === +route.params.part){
                answer.part_items.forEach((e)=>{
                  const find = list.value.find((item) => item?.part_item_id === e?.part_item_id);
                  if (find) {
                    find.value_info = e.value_info
                    find.is_help = e.is_help
                    find['help_message'] = e?.help_message || ''
                  }
                })
              }
            })
          }
          nextTick(() => {
            originListStr.value = JSON.stringify(answerList.value)
          })
        }, 100)
      }
      if (hasEdited.value) {
        let flag = null
          MessageBox({
            message: '此分類尚未儲存，請先儲存再進行動作避免資料遺失。',
            cancelButtonText: '繼續編輯',
            confirmButtonText: '不保存離開此頁',
            confirmBtnColor: 'secondary',
            cancelBtnColor: 'primary',
            onConfirm: () => {
              flag = false
            },
            onCancel: () => {
              flag = true
            },
          })
        let p = new Promise((resolve) => {
          const timer = setInterval(() => {
            if (flag !== null) {
              clearInterval(timer)
              resolve(flag)
            }
          }, 30)
        })
        const saveConfirm = await p
        if (saveConfirm) {
          flag = null
          return false
        } else {
          leave()
          return true
        }
      } else {
        leave()
      }
    })
    // const editData = (event) => {
    //   if (event) {
    //     console.log(1)
    //     const Index = list.value.findIndex((e) => e.part_item_id === event.id)
    //     if (Index > 0) {
    //       list.value[Index].extension_info.rows[event.rowIndex][
    //         `answer${event.colIndex}`
    //       ] = list.value[Index].value_info[event.rowIndex][event.colIndex]
    //     }
    //   }
    // }
    const ChangeHelpText = (info) => {
      const updateObj = {
        part_item_id: info.part_item_id,
        type: info.type,
        is_help: +info.is_help ? '1' : '0',
        help_message: info?.help_message ||'',
        is_finish: false,
        value_info: '',
      }
      questionnaireAnswer(updateObj);
    };
    const getQue = async () => {
      const resp = await getQuestionnaireList()
      if (resp.error) {
        showMsgBox.value = true
        errorMsg.value = resp.msg
        errorCode.value = resp.error
      } else {
        if (resp.ret.data.length === 0) {
          showMsgBox.value = true
          errorMsg.value = '目前無問卷可填答'
          errorCode.value = 'noQue'
          return
        }
        questionnaireId.value = resp.ret.data[0].id
        const res = await getQuestionnaire({ id: resp.ret.data[0].id })
        if (res.error) {
          showMsgBox.value = true
          errorMsg.value = res.msg
          errorCode.value = res.error
        } else {
          if (res.ret.info.length === 0) {
            showMsgBox.value = true
            errorMsg.value = '目前無問卷可填答'
            errorCode.value = 'noQue'
          } else {
            id.value = resp.ret.data[0].id

            //vincent
            // eslint-disable-next-line no-unused-vars
            const routerId = Number(route.params?.id) || NaN;
            // eslint-disable-next-line no-unused-vars
            const routerPart = Number(route.params?.part) || NaN;

            const partIdList = res.ret.info.part.map(item => item.part_id);

            if (
              routerId &&
              routerPart &&
              resp.ret.data[0].id === routerId &&
              partIdList.includes(routerPart)
            ) {
              router.push(`/questionnaire/${routerId}/${routerPart}`)
            } else {
              router.push(`/questionnaire/${resp.ret.data[0].id}/${res.ret.info.part[0].part_id}`)
            }
            
            title.value = res.ret.info.title
            partList.value = res.ret.info.part
            for (const i in partList.value) {
              for (const v in i.items) {
                v.value_info = null
              }
            }
            list.value = res.ret.info.part.find((e) => {
              return +e.part_id === +route.params.part
            })?.items
            if (list.value) {

              list.value.forEach((e) => (e.value_info = null))
              list.value.reduce((accu, cur) => {
                if (cur.type !== ItemTypes.Introduction) {
                  cur.itemIndex = accu
                  return accu + 1
                }else{
                  return accu
                }
              }, 1)
            }
            questionnaireId.value = res.ret.info.id
            partTitle.value = partList.value?.find((e) => {
              return e.id === +route.params.id
            })?.title
          }
        }
      }
      await getFillQue()
    }
    const hasEdited = computed(() => {
      const originList = JSON.parse(originListStr.value);
      // const originListIndex = originList.findIndex(item=>{
      //   return +item.part_id === +route.params.part});
      //   if(originListIndex < 0) return false
      // const sortedOrigin = originList[originListIndex].part_items;
      const sortedCurrent = JSON.parse(JSON.stringify(answerList.value)).map(
        (obj) => {
          return Object.fromEntries(Object.entries(obj).sort())
        },
      )
      let sortedOriginMap = {};
      originList.forEach((item)=>{
        sortedOriginMap[item.part_item_id]=item;
      })
      for (const sortedCurrentItem of sortedCurrent) {
          const originItem = sortedOriginMap[sortedCurrentItem.part_item_id];
          // if(originItem?.type=="DynamicForm") continue
          // if(originItem?.type=='ColumnInput') continue
        for (const sortedCurrentItemKey in sortedCurrentItem) {
          try{
            const originItemValue = JSON.stringify(originItem[sortedCurrentItemKey]);
            const sortedCurrentValue = JSON.stringify(sortedCurrentItem[sortedCurrentItemKey]);
            if(originItemValue !== sortedCurrentValue){
              if(sortedCurrentItemKey !== 'is_help' || sortedCurrentItemKey !== 'is_finish' || sortedCurrentItemKey !== 'help_message'){
                console.log(2, originItemValue, sortedCurrentValue, sortedCurrentItemKey) 
                return true
              }
            }
          }catch (e){
            continue
          }

        }
      }
      return false;
      // const sortedOrigin = JSON.parse(originListStr.value).map((obj) => {
      //   return Object.fromEntries(Object.entries(obj).sort())
      // })

      // const sortedCurrent = JSON.parse(JSON.stringify(answerList.value)).map(
      //   (obj) => {
      //     return Object.fromEntries(Object.entries(obj).sort())
      //   },
      // )
      // return JSON.stringify(sortedOrigin) !== JSON.stringify(sortedCurrent)
    })
    const beforeUnloadListener = (event) => {
      if (hasEdited.value) {
        event.preventDefault()
        return (event.returnValue = 'Are you sure you want to exit?')
      }
    }
    window.addEventListener('beforeunload', beforeUnloadListener, {
      capture: true,
    })
    const getFillQue = async () => {
      const res = await getFillInfo({
        id: route.params.id ? route.params.id : questionnaireId.value,
        part_id: route.params.part,
      })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        fillList.value = res.ret.info.result_items
        finishCount.value = res.ret.info.finish_count
        dataId.value = fillList.value?.id
        isConfirm.value = +res.ret.info.is_confirm === 1
        nextTick(() => {
          originListStr.value = JSON.stringify(fillList.value)
        })
        fillList.value?.forEach((answer) => {
          if(+answer.part_id === +route.params.part){
            answer.part_items.forEach((e)=>{
              const find = list.value.find((item) => item?.part_item_id === e?.part_item_id);
              if (find) {
                find.value_info = e.value_info
                find.is_help = e.is_help
                // modify help message
                find['help_message'] = e?.help_message || ''
              }
            })
          }
        })
      }
    }
    const questionnaireAnswer = (e) => {
      const findId = answerList.value.findIndex(
        (item) => item.part_item_id === e.part_item_id,
      )
      if (findId === -1) {
        answerList.value.push(e)
      } else {
        answerList.value.splice(findId, 1, e)
      }
    }
    const editQue = async () => {
      const fillInfo = await getFillInfo({ id: route.params.id })
      if (fillInfo.error) {
        showMsgBox.value = true
        errorMsg.value = fillInfo.msg
        errorCode.value = fillInfo.error
      } else {
        let answers = fillInfo.ret.info.result_items
        if(answers){
          const item = answers.find(e=>+e.part_id === +route.params.part)
          if(item){
            item.part_items = answerList.value
          }else{
            answers.push({
              part_id: +route.params.part,
              part_items: answerList.value
            })
          }
        }else{
          answers = [{
            part_id: +route.params.part,
            part_items: answerList.value
          }]
        }
        const res = await fillQuestionnaire({
          id: questionnaireId.value,
          action: SAVE_ACTION_SAVE,
          data: [
            ...answers,
          ],
        })
        if (res.error) {
          showMsgBox.value = true
          errorMsg.value = res.msg
          errorCode.value = res.error
        } else {
          showMsgBox.value = true
          errorMsg.value = '儲存成功'
          window.removeEventListener('beforeunload', beforeUnloadListener, {
            capture: true,
          })
          getFillQue(); // 刷新sortedOriginMap
        }
      }
    }
    
    onBeforeUnmount(() => {
      window.removeEventListener('beforeunload', beforeUnloadListener, {
        capture: true,
      })
    })
    const saveQue = async () => {
      let answers
      const fillInfo = await getFillInfo({id: route.params.id})
      if (fillInfo.error) {
        showMsgBox.value = true
        errorMsg.value = fillInfo.msg
        errorCode.value = fillInfo.error
      } else {
        answers = fillInfo.ret.info.result_items
        if(answers){
          const item = answers.find(e=>+e.part_id === +route.params.part)
          if(item){
            item.part_items = answerList.value
          }else{
            answers.push({
              part_id: +route.params.part,
              part_items: answerList.value
            })
          }
        }else{
          answers = [{
              part_id: +route.params.part,
              part_items: answerList.value
            }]
        }
        if(answers.length !== partList.value.length){
          partList.value.forEach(e=>{
            const has = answers.find(x=>x.part_id === e.part_id)
            if(!has){
              answers.push({
                part_id: e.part_id,
                part_items: []
              })
            }
          })
        }
      }
      const res = await fillQuestionnaire({
        id: questionnaireId.value,
        action: SAVE_ACTION_CONFIRM,
        data: [
          ...answers,
        ],
      })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        MessageBox({
          message: '送出成功',
          showCancelButton: false,
          onConfirm: () => {
            window.removeEventListener('beforeunload', beforeUnloadListener, {
              capture: true,
            })
            location.reload()
          },
        })
      }
    }

    onMounted(async () => {
      await getQue()
      getNestAndFormId()
      originListStr.value = JSON.stringify(answerList.value)
    })
    return {
      ChangeHelpText,
      title,
      list,
      getQue,
      errorCode,
      errorMsg,
      showMsgBox,
      questionnaireAnswer,
      answerList,
      questionnaireId,
      dataId,
      editQue,
      fillList,
      getFillQue,
      saveQue,
      partList,
      isConfirm,
      enlargeImg,
      originAnswerList,
      partTitle,
      getNestAndFormId,
      getFillList,
      x,
      hasEdited,
      finishCount,
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 30px 40px;
  width: calc(100vw - 255px);
  right: 0;
  position: fixed;
  top: 0;
  z-index: 1;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
  margin: 0;
}
h2 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 33px;
  color: #000000;
}
.body {
  width: calc(100vw - 255px);
  white-space: pre-line;
}
.topic {
  font-size: 16px;
}
.submit-button {
  margin-top: 88px;
  margin-bottom: 107px;
  max-width: 200px;
  width: 100%;
}
.que-content {
  margin-top: 150px;
}
.intro {
  margin-top: 3rem;
  margin-bottom: 2rem;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 2px;
  color: #4d4d4d;
}
.is-published-wrapper {
  width: calc(100vw - 255px);
  height: 100%;
  background-color: rgba($color: #fff, $alpha: 0.5);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  position: fixed;
  p {
    border: 1px dashed #177baf;
    color: #177baf;
    padding: 10px;
    border-radius: 5px;
  }
}
.remark {
  font-size: 14px;
  color: rgba($color: #000000, $alpha: 0.5);
}
.enlarge {
  width: 20px;
  position: absolute;
  right: 5px;
  bottom: 30px;
  display: none;
}
.preview-img {
  width: 200px;
  position: relative;
  &:hover {
    .enlarge {
      display: block;
    }
  }
}
.item-title {
  font-size: 20px;
  font-weight: 600;
  padding-bottom: 10px;
}
.not-sure{
  border:none;
  background-color: #F9BA0D;
  border: 1px solid #F9BA0D;
  color: #fff;
  border-radius: 5px;
  font-size: 15px;
  line-height: 30px;
  padding: 0 18px;
  margin-left: 10px;
  &:hover{
    background-color: #fdcb41;
  }
}
.sure-active{
  background-color: #fff;
  border: 1px solid #F9BA0D;
  color: #F9BA0D;
  &:hover{
    background-color: #ffefc3;
  }
}
</style>
